// NoCourseSelected.jsx
import React from 'react';

const NoCourseSelected = () => (
  <div className="no-course-selected">
    <p>Please select a course to edit its structure.</p>
  </div>
);

export default NoCourseSelected;